import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { FathomKeyForm } from "@/components/team/FathomKeyForm";

export interface FathomKeyModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  closer: { id: string; name: string; fathom_api_key_vault_ref: string | null } | null;
  onSuccess: () => void;
}

/**
 * Thin Dialog wrapper around the shared {@link FathomKeyForm}.
 *
 * Phase 16 plan 16-05 (D-13) extracted all form state + edge-function
 * plumbing into FathomKeyForm so that both this admin modal and the new
 * /closer/fathom page consume the same component.
 */
export function FathomKeyModal({ open, onOpenChange, closer, onSuccess }: FathomKeyModalProps) {
  if (!closer) return null;

  const isRotateMode = !!closer.fathom_api_key_vault_ref;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-surface border-border sm:max-w-md">
        <DialogHeader>
          <DialogTitle>
            {isRotateMode ? "Rotate Fathom Key" : "Connect Fathom"}
          </DialogTitle>
          <DialogDescription>
            {isRotateMode
              ? `Replace the Fathom API key for ${closer.name}. The old key will be removed.`
              : `Connect a Fathom API key for ${closer.name} to enable demo recording sync.`}
          </DialogDescription>
        </DialogHeader>

        <FathomKeyForm
          closer={closer}
          onSuccess={onSuccess}
          onDone={() => onOpenChange(false)}
        />
      </DialogContent>
    </Dialog>
  );
}
